import { frontendURL } from '../../../helper/URLHelper';

const MasterAiView = () => import('./MasterAiView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/master-ai'),
    name: 'master_ai_view',
    meta: {
      permissions: ['administrator'],
    },
    component: MasterAiView,
  },
];
